import { post } from '@/utils/network/axios-helper';
import type { IPageDataBoxType, IGetAnswerList, ISaveAnswerList, IParamsType, IResult } from '@/utils/ctype';

export const getReadingContent = (params: IParamsType) => {
  return post<{list: IPageDataBoxType[];}>('/api/simulate/get-reading-info', params);
};

export const getAnswerList = (params: IParamsType) => {
  return post<IGetAnswerList>('/api/simulate/get-reading-draft-info', params);
};

export const saveAnswerList = (params: ISaveAnswerList) => {
  return post<{id: number;}>('/api/simulate/save-reading-info', params);
};

export const submitAnswer = (params: IParamsType) => {
  return post<{id: number;}>('/api/simulate/finished-reading', params);
};

export const getResult = (params: IParamsType) => {
  return post<IResult>('/api/simulate/get-reading-record-answer-info', params);
};